export const logoResolutionSizes: Record<
  string,
  Record<string, { width: number; height: number }>
> = {
  horizontal: {
    error: {
      width: 360,
      height: 72
    },
    warning: {
      width: 960,
      height: 192
    }
  },
  square: {
    error: {
      width: 128,
      height: 128
    },
    warning: {
      width: 341,
      height: 341
    }
  }
};
